import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";

export default class InvalidAttributeException extends Error {
    constructor(attributeName: string, type: string) {
        const message = `Invalid attribute [${attributeName}]! Expected type <${type}>!`;

        super(message);

        DiagnosticsStore.collectEventLog("error", message);
    }
}
